// extracted by mini-css-extract-plugin
export default {"root":"n8JXw","title":"utIVI","subtitle":"nUBEj"};